import type { Subscription } from '../../../../../types';

import AsyncActionButton from '@blueshift-ui/inputs/dist/components/async-action-button';
import { TrackedButton } from '@blueshift-ui/analytics';
import { add } from 'date-fns';
import useTranslation from '@blueshift-ui/i18n/dist/hooks/use-translation';
import useUpdateSubscription from '../../../../../hooks/subscription/use-update-subscription';

interface ConfirmUpdateProps {
  currentSubscription: Subscription;
  newSubscription: Subscription;
  onRejected?: () => void;
  onResolved?: () => void;
}

function ConfirmUpdateButton({
  currentSubscription,
  newSubscription,
  ...buttonProps
}: ConfirmUpdateProps) {
  const { translate } = useTranslation('update_membership');
  const { makeRequestUpdateSubscription } = useUpdateSubscription({ currentSubscription });
  const disabled = currentSubscription.id === newSubscription.id;

  async function handleClick() {
    await makeRequestUpdateSubscription({
      parameters: {
        new_item_id: newSubscription.item_id,
        new_purchase_price_cents: newSubscription.purchase_price_cents,
        old_item_id: currentSubscription.item_id,
        old_purchase_price_cents: currentSubscription.purchase_price_cents,
      },
      scheduled_at: add(new Date(currentSubscription.next_billing_date), {
        hours: -2,
      }).toISOString(),
      transformation_type: 'membership_change_requested',
    });
  }

  return (
    <AsyncActionButton
      {...buttonProps}
      action={handleClick}
      component={TrackedButton}
      disabled={disabled}
      id="update_membership_plan_button"
    >
      {translate('confirm_cta', '')}
    </AsyncActionButton>
  );
}

export default ConfirmUpdateButton;
